<div class="row align-top gutters">
  <div class="col-md-12">
    <div class="asset-management-subheaders">Asset Management Details</div>
  </div>
</div>

@if (permissions.creawebAssetManagementFieldPermissions._edit) {
  <div class="row align-top gutters">
    <div class="col-md-12">
      <button class="edit-button" mat-raised-button (click)="toggleEditMode()">
        @if (!isEditMode) {
          <span>Edit</span>
        }
        @if (isEditMode) {
          <span>Save</span>
        }
      </button>
    </div>
  </div>
}

<div class="row align-top gutters top-padding">
  <div class="col-md-6">
    <div class="mat-elevation-z8">
      <table mat-table class="stripped-table" #assetManagementTable
        [dataSource]="dataSource">

        <!-- Field Column -->
        <ng-container matColumnDef="field">
          <th mat-header-cell *matHeaderCellDef> Field </th>
          <td mat-cell class="name-column" *matCellDef="let row"> {{row.field}} </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Value </th>
          <td mat-cell *matCellDef="let row">
            @if (!isEditMode || !permissions.creawebAssetManagementFieldPermissions._edit) {
              <span>{{row.value}}</span>
            }
            @if (isEditMode && permissions.creawebAssetManagementFieldPermissions._edit) {
              <mat-form-field>
                <mat-label>Select Green Features</mat-label>
                <mat-select [(value)]="newGreen">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                  <mat-option [value]="'n/a'">N/A</mat-option>
                </mat-select>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
      </table>
    </div>
  </div>
</div>

<div class="row align-top gutters">
  <div class="col-md-6">
    <div [ngClass]="permissions.creawebAssetManagementFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span></span>
      }
      Special Needs Set Aside Description
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleSpecialEditMode()">
            @if (!specialEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (specialEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebAssetManagementFieldPermissions._edit || !specialEditMode) {
      <div>
        @if (specialNeeds !== '') {
          <div class="notes-read-only">{{specialNeeds}}</div>
        }
        @if (specialNeeds === '') {
          <em>There are no Special Needs Set Aside Description for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebAssetManagementFieldPermissions._edit && specialEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Special Needs Set Aside Description here</mat-label>
          <textarea matInput
            [formControl]="special"
          (change)="specialChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <div class="col-md-6">
    <div [ngClass]="permissions.creawebAssetManagementFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span></span>
      }
      Green Building Certifications
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleGreenBuildingEditMode()">
            @if (!greenBuildingEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (greenBuildingEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebAssetManagementFieldPermissions._edit || !greenBuildingEditMode) {
      <div>
        @if (greenBuilding !== '') {
          <div class="notes-read-only">{{greenBuilding}}</div>
        }
        @if (greenBuilding === '') {
          <em>There are no Green Building Certifications for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebAssetManagementFieldPermissions._edit && greenBuildingEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Green Building Certifications here</mat-label>
          <textarea matInput
            [formControl]="greenB"
          (change)="greenBuildingChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>
  <div class="col-md-6">
    <div [ngClass]="permissions.creawebAssetManagementFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span></span>
      }
      Other Green Features
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleOtherGreenEditMode()">
            @if (!otherGreenEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (otherGreenEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebAssetManagementFieldPermissions._edit || !otherGreenEditMode) {
      <div>
        @if (otherGreen !== '') {
          <div class="notes-read-only">{{otherGreen}}</div>
        }
        @if (otherGreen === '') {
          <em>There are no Other Green Features for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebAssetManagementFieldPermissions._edit && otherGreenEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Other Green Features here</mat-label>
          <textarea matInput
            [formControl]="otherG"
          (change)="otherGreenChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <div class="col-md-6">
    <div [ngClass]="permissions.creawebAssetManagementFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span></span>
      }
      Other Reports
      @if (permissions.creawebAssetManagementFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleOtherReportsEditMode()">
            @if (!otherReportsEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (otherReportsEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebAssetManagementFieldPermissions._edit || !otherReportsEditMode) {
      <div>
        @if (otherReports !== '') {
          <div class="notes-read-only">{{otherReports}}</div>
        }
        @if (otherReports === '') {
          <em>There are no Other Reports for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebAssetManagementFieldPermissions._edit && otherReportsEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Other Reports here</mat-label>
          <textarea matInput
            [formControl]="otherR"
          (change)="otherReportsChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <!--  <div class="col-md-6">-->
  <!--    <div class="subsection-header gray">Other Reports</div>-->
  <!--    <span *ngIf="assetManagement && assetManagement.other_reports">{{assetManagement.other_reports}}</span>-->
  <!--    <i *ngIf="!assetManagement || !assetManagement.other_reports">There are no Other Reports for this deal.</i>-->
<!--  </div>-->
</div>

